export class LoginProviderClassModel {
    name: string;
    id: string;
    url: string;
  }